export default "__VITE_ASSET__a35b3fd8__"